// File: /src/services/LogsService.js

import apiClient from './apiClient';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const fetchLogs = async () => {
	try {
		const response = await apiClient.get(API_ENDPOINTS.LOGS);
		return response.data;
	} catch (error) {
		console.error('Erro ao buscar logs:', error);
		throw error;
	}
};
